import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { catchError, publishReplay, refCount } from "rxjs/operators";
import { of } from "rxjs";
import { ApiService } from "./api.service";

@Injectable()
export class ConfigurationService {
    private config: string[][] = [];

    constructor(private apiService: ApiService) { }

    public get(key: string): Observable<string> {
        const cacheKey: string = key;

        if (!this.config[cacheKey]) {
            const params: object = {
                key
            };
            this.config[cacheKey] = this.apiService.callServicePostToCollection("configuration.get", params).pipe(
                catchError(error => of([])),
                publishReplay(1),
                refCount()
            );
        }

        return this.config[cacheKey];
    }
}
